
import { useKpiCardsState } from './hooks/useKpiCardsState';
import { useEditMode } from './hooks/useEditMode';
import { useCardMovement } from './hooks/useCardMovement';
import { useQaTesting } from './hooks/useQaTesting';

/**
 * Main hook that combines all dashboard state hooks
 * This is used by the DashboardProvider to create the context value
 */
export const useDashboardState = () => {
  // KPI cards state and management
  const { 
    kpiCards, 
    setKpiCards, 
    addKpiCard, 
    updateKpiCard, 
    removeKpiCard 
  } = useKpiCardsState();
  
  // Edit mode state and toggling
  const { isEditMode, toggleEditMode } = useEditMode();
  
  // Card movement functionality
  const { moveKpiCard } = useCardMovement(kpiCards, setKpiCards);
  
  // Run QA testing to automatically position cards (for testing purposes)
  useQaTesting(kpiCards, setKpiCards);

  // Provide empty drag and drop methods to disable functionality
  const dragStart = (id: string) => {
    console.log('Drag and drop disabled on homepage');
  };
  
  const dragOver = (id: string) => {
    console.log('Drag and drop disabled on homepage');
  };
  
  const drop = () => {
    console.log('Drag and drop disabled on homepage');
  };

  // Return all state and functions needed by consumers
  return {
    kpiCards,
    addKpiCard,
    updateKpiCard,
    removeKpiCard,
    moveKpiCard,
    isEditMode,
    toggleEditMode,
    dragStart,
    dragOver,
    drop,
    draggedCardId: null,
    dragOverCardId: null
  };
};
